import React from 'react'
import _ from 'underscore'
import moment from 'moment'

class DateComponent extends React.Component {

  render() {
    if (_.isEmpty(this.props.date)) {
      return null
    }

    const formatted = moment(this.props.date).format("YYYY-MM-DD")

    return (
      <span>{formatted}</span>
    )
  }
}
    
export default DateComponent
